// allows to call certain function only once
export const callOnce = (callable) => {
  if (!window.functionsCalled) {
    window.functionsCalled = {};
  }

  if (typeof callable === 'function') {
    if (!window.functionsCalled.hasOwnProperty(callable)) {
      window.functionsCalled[callable] = true;
      callable();
    }
  }
};
